<template>
  <div id="chart-line" style="position:relative;">
    <apexchart
      ref="apexCepstrum"
      id="apexCepstrum"
      v-observe-visibility="visibilityChanged"
      type="line"
      height="360"
      :options="chartOptions"
      :series="series"
    ></apexchart>
      <ChartTimeMini
      :unit="sensorUnit"
  :rawData="rawData"
  :samplingRate="samplingRate"
  v-model="visibleRange"
  v-on:childTimeDomain="updateTimeChartMinMax"
  ></ChartTimeMini>
    <div
      style="
        order: 0;
        position: absolute;
        top: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: row;
        width: 100%;
      "
    >
      <div style="margin: 5px" @click="Backward">
        <el-button size="mini"><em class="fas fa-backward"></em> </el-button>
      </div>
      <div style="margin: 5px" @click="StepBackward">
        <el-button size="mini"><em class="fas fa-step-backward"></em> </el-button>
      </div>
      <div style="margin: 5px; font-size: 20px; text-align: center">
        {{ Scnd }}<br />{{ Value }}
      </div>
      <div style="margin: 5px" @click="StepForward">
        <el-button size="mini"><em class="fas fa-step-forward"></em> </el-button>
      </div>
      <div style="margin: 5px" @click="Forward">
        <el-button size="mini"><em class="fas fa-forward"></em> </el-button>
      </div>
    </div>
    <span style="position: absolute; top: 10px; left: 50px">
      <span style="margin-top: 0px">{{
          `${this.timeChartMinMax[0].toFixed(2)} - ${this.timeChartMinMax[1].toFixed(2)} 
          ${$t("common.second")}`
      }}</span>
    </span>
    <span style="position: absolute; top: 10px; right: 50px">
      <span>
        <span style="margin-top: 0px">Zoom: {{ zoomLevel + 1 }}X</span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomIn">
          <el-button size="mini"><em class="fas fa-search-plus"></em> </el-button
        ></span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomOut">
          <el-button size="mini"><em class="fas fa-search-minus"></em> </el-button
        ></span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomReset">
          <el-button size="mini"><em class="fas fa-home"></em> </el-button
        ></span>
        <span style="margin-left: 5px; z-index: 9999">
          <el-dropdown size="mini" @command="handleCommand" trigger="click">
            <el-button size="mini">
              {{ $t("common.download") }}
              <em class="fas fa-download"></em>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="csvDownload">
                {{ $t("common.csvDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="pngDownload">
                {{ $t("common.pngDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="svgDownload">
                {{ $t("common.svgDownload") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <br />
      </span>
    </span>
    <el-row class="toolbox">
      <el-col>
        <el-form
          ref="form"
          inline
          label-position="top"
          label-width="100px"
          size="small"
        >
          <el-form-item :label="$t('measurement.window')">
            <el-select v-model="window">
              <el-option
                v-for="window in windows"
                :key="window"
                :label="window"
                :value="window"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import { apexDownload, Keyboard } from "../util";
import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini"
export default {
  name: "cepstrum-chart",
  events: [],
  props: {
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
    sensor:{
      type:String,
      default:'accelerometer'
    }
  },
  components: {
    apexchart: VueApexCharts,
    ChartTimeMini
  },
  data() {
    return {
      mouseBeforeX: 0,
      mouseAfterX: 0,
      activeDataPointIndex: 0,
      timeDomain: [],
      timeChartMinMax:[0,0],
      visibleRange:[],
      activeData: "",
      zoomLevel: 0,
      zoomOffset: 20,
      window: "rectangular",
      TimeSerie: [],
      series: [
        {
          data: [],
        },
      ],
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
      anootationPosition: 0,
      chartOptions: {
        tooltip: {
          enabled: true,
          shared: true,
          followCursor: false,
          style: {
            fontSize: "10px",
            fontFamily: undefined,
          },
          onDatasetHover: {},
          x: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        chart: {
          id: "chart",
          type: "line",
          defaultLocale: "en",
          locales: [
            {
              name: "en",
              options: {
                toolbar: {
                  exportToSVG: this.$t("chart.toolbar.exportToSVG"),
                  exportToPNG: this.$t("chart.toolbar.exportToPNG"),
                  exportToCSV: this.$t("chart.toolbar.exportToCSV"),
                  menu: this.$t("chart.toolbar.menu"),
                  selection: this.$t("chart.toolbar.selection"),
                  selectionZoom: this.$t("chart.toolbar.selectionZoom"),
                  zoomIn: this.$t("chart.toolbar.zoomIn"),
                  zoomOut: this.$t("chart.toolbar.zoomOut"),
                  pan: this.$t("chart.toolbar.pan"),
                  reset: this.$t("chart.toolbar.reset"),
                },
              },
            },
          ],
          zoom: {
            autoScaleYaxis: true,
          },
          events: {
            click: this.dataPointClick,
            updated: this.chartUpdated,
          },
          animations: {
            enabled: false,
            dynamicAnimation: {
              enabled: false,
            },
          },
          toolbar: {
            tools: {
              download: false,
              pan: true,
              zoom: false,
              zoomin: false,
              zoomout: false,
              reset: false,
            },
            autoSelected: "pan",
            show: true,
          },
        },
        annotations: {
          xaxis: [],
        },
        colors: ["#0071BD"],
        stroke: {
          width: 2,
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          type: "numeric",
          tickAmount: 20,
        },
        yaxis: {
          labels: {
            formatter: function (e) {
              return parseFloat(e).toFixed(2);
            },
          },
        },
        grid: {
          show: !0,
          padding: {
            top: 50,
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        theme: {},
      },
    };
  },
  mounted() {
    
    this.visibleRange = [0,this.rawData.length-1]
    window.addEventListener("mousedown", this.mouseDown);
  },
  computed: {
    sensorUnit:function(){
      switch(this.sensor){
        case 'current':return "A";
        case 'voltage':return "V";
      }
      return "G"
    },
    ...mapState("measurementsDetails", ["rawdataIndex"]),
    Scnd: function () {
      return (
        Number(this.timeDomain[this.activeDataPointIndex]).toFixed(4) + ` s`
      );
    },
    Value: function () {
      try {
        if (!this.activeData.length) return "";
        return this.activeData[this.activeDataPointIndex].toFixed(4) + "G";
      } catch (e) {
        return 0;
      }
    },
  },
  methods: {
     chartUpdated() {
      this.BindKeyborad();
      this.chartLoading = false;
      this.drawAnnotations();
    },
    updateTimeChartMinMax(timeDomain){
      this.timeChartMinMax=timeDomain
    },
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    handleCommand(command) {
      switch (command) {
        case "csvDownload":
          apexDownload.csvDownload(this, "apexCepstrum");
          break;
        case "pngDownload":
          apexDownload.pngDownload(this);
          break;
        case "svgDownload":
          apexDownload.svgDownload(this);
          break;
      }
      setTimeout(() => {
        this.init();
      }, 100);
    },
    visibilityChanged(a) {
      if (a) {
        this.init();
      }
    },
    DC_Offset(data) {
      const average = data.reduce((p, c) => p + c, 0) / data.length; // calculate average
      var normalized = data.map((x) => x - average); // normalize raw data by subtracting average and multiplying by gravity constant
      return normalized;
    },
    init() {
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/cepstrum`, {
          half: true,
          window:this.window,
          dcOffset: true,
          mode: this.fftType == "Vrms" ? "velocity" : "accelerometer",
                    signal: this.rawData.slice(this.visibleRange[0],this.visibleRange[1]),
          samplingRate: this.samplingRate,
        })
        .then((response) => {
          this.timeDomain = response.data.results.x;
          this.activeData = response.data.results.y;

          this.PrepareDataToPlot().then(() => {
            this.$refs.apexCepstrum.zoomX(
              this.timeDomain[0],
              this.timeDomain[this.timeDomain.length - 1]
            );
            this.zoom();
          });
        });
    },
    async PrepareDataToPlot() {
      let name = "Gamnitude";
      this.chartOptions = {
        xaxis: {
          title: {
            text: `${this.$t("chart.quefrency")} (s)`,
            offsetY: 70,
          },
          categories: this.timeDomain,
          labels: {
            formatter: function (val) {
              if (val) {
                return val.toFixed(2);
              } else {
                return "";
              }
            },
          },
        },
        yaxis: {
          tickAmount: 10,
          title: {
            text: "Gamnitude",
          },
          labels: {
            formatter: function (e) {
              return parseFloat(e).toFixed(4);
            },
          },
        },
      };
      this.series = [
        {
          name: name,
          data: this.activeData,
        },
      ];
    },
    dataPointClick(event, chartContext, config) {
      this.mouseAfterX = event.offsetX;
      if (
        Math.abs(this.mouseAfterX - this.mouseBeforeX) < 5 &&
        !event.ctrlKey
      ) {
        this.$message({
          type: "info",
          message: this.$t("chart.warningForCTRLClick"),
        });
      }
      if (event.ctrlKey) {
        if (config.dataPointIndex == -1) return;
        this.$refs.apexCepstrum.clearAnnotations();
        this.activeDataPointIndex = config.dataPointIndex;
        this.drawAnnotations();
      }
    },
    drawAnnotations() {
      this.$refs.apexCepstrum.clearAnnotations();
      try {
        var x = this.timeDomain[this.activeDataPointIndex];
        let annotation = {
          x,
          borderColor: "#775DD0",
          label: {
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `${this.activeData[this.activeDataPointIndex].toFixed(4)}`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexCepstrum.addXaxisAnnotation(annotation, false);
      } catch (e) {
        console.error(e);
      }
    },
    Backward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 10;
      this.drawAnnotations();
    },
    Forward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 10;
      this.drawAnnotations();
    },
    StepBackward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 1;
      this.drawAnnotations();
    },
    StepForward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 1;
      this.drawAnnotations();
    },
    BindKeyborad() {
      Keyboard.detach(this.$refs.apexCepstrum.$el);
      Keyboard.attach(this.$refs.apexCepstrum.$el);
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowLeft",
        callback: this.Backward,
      });
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowRight",
        callback: this.Forward,
      });
      Keyboard.add_binding({
        key: "ArrowLeft",
        callback: this.StepBackward,
      }),
        Keyboard.add_binding({
          key: "ArrowRight",
          callback: this.StepForward,
        });
      Keyboard.add_binding({
        key: "Enter",
        callback: () => {
          this.zoomReset();
        },
      });
      Keyboard.add_binding({
        key: "ArrowUp",
        callback: () => {
          this.zoomIn();
        },
      });
      Keyboard.add_binding({
        key: "ArrowDown",
        callback: () => {
          this.zoomOut();
        },
      });
      this.drawAnnotations();
    },
    zoomIn() {
      if (this.zoomLevel + 1 > this.maxZoomLevel) {
        return;
      }
      this.zoomLevel = this.zoomLevel + 1;
      this.zoom();
    },
    zoomOut() {
      if (this.zoomLevel - 1 < 0) {
        return;
      }
      this.zoomLevel = this.zoomLevel - 1;
      this.zoom();
    },
    zoomReset() {
      // let x = this.closestValueIndex(
      //   this.timeDomain,
      //   this.referenceFrequency
      // );
      // this.activeDataPointIndex = x;
      this.zoomLevel = 0;
      this.zoom();
    },
    zoom() {
      let offset =
        this.timeDomain[this.timeDomain.length - 1] /
        Math.pow(2, this.zoomLevel);
      let centerValue = this.timeDomain[this.activeDataPointIndex];
      let min = centerValue - offset;
      let max = centerValue + offset;
      if (min < 0) min = this.timeDomain[0];
      if (this.zoomLevel == 0) {
        this.$refs.apexCepstrum.zoomX(
          this.timeDomain[0],
          this.timeDomain[this.timeDomain.length - 1]
        );
      } else {
        this.$refs.apexCepstrum.zoomX(min, max);
      }

      this.drawAnnotations();
    },
  },
  watch: {
      visibleRange:function(range){
        this.init();
    },
    rawData: function () {
      this.init();
    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}
*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}
.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
